


export const MAIN_API = process.env.REACT_APP_MAIN_API;
